import { get } from 'lodash';
import {
	currentUserWhoCanAuthorise,
	getDefaultAuthoriser,
	singleAuthoriserFilter,
	multiAuthoriserFilter,
	authoriserMap,
	reorderAuthoriserList,
} from '../utils/authoriserUtils';

export const getAuthorisationInfo = (userId, payload) => {
	// FPS, CHAPS use the multipart, so the authorisation (payload) response might be wrapped in a 'body' key
	const authorisation = get(payload, 'body', payload);
	payload.code && (authorisation.responseCode = payload.code);

	const userList = get(authorisation, 'user_list', []);
	const singleAuthoriserList = userList.filter(singleAuthoriserFilter).map(authoriserMap);
	let multiAuthoriserList = userList.filter(multiAuthoriserFilter).map(authoriserMap);
	multiAuthoriserList = reorderAuthoriserList(userId, multiAuthoriserList);

	const status = get(authorisation, 'status', '');

	const authorisers = getDefaultAuthoriser(userId, status, singleAuthoriserList, multiAuthoriserList);
	const isDefaultAuthorisers = !!authorisers.length;

	// If the current user is in the approvers group, filter out everyone else otherwise send them all
	const currentUserApprover = currentUserWhoCanAuthorise(userId, userList);
	const authorisersGroup = !!currentUserApprover ? [currentUserApprover] : userList;

	return {
		authorisation,
		singleAuthoriserList,
		multiAuthoriserList,
		authorisers,
		authorisersGroup,
		isDefaultAuthorisers,
	};
};
